import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=f8a4c6f2&"
import script from "./ButtonList.vue?vue&type=script&lang=js&"
export * from "./ButtonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports